import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SecurityPassRoutingModule } from './security-pass-routing.module';
import { VisitorPassComponent } from './components/visitor-pass/visitor-pass.component';
import { SecurityPassComponent } from './security-pass.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { QRCodeModule } from 'angularx-qrcode';
import { UserAdditionalDetailsComponent } from './components/user-additional-details/user-additional-details.component';
import { VisitorEntryComponent } from './components/visitor-entry/visitor-entry.component';
import { HostApprovalComponent } from './components/host-approval/host-approval.component';
import { SecurityContainerComponent } from './components/security-container/security-container.component';
import { DialogPopUpsModule } from 'src/app/common/modules/dialog-pop-ups/dialog-pop-ups.module';
import { EmployeeRegistrationFormComponent } from './components/employee-registration-form/employee-registration-form.component';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input-v16';
import { AumyeEmergencyRespondComponent } from './components/aumye-emergency-respond/aumye-emergency-respond.component';
import { HostVisitorStatusComponent } from './components/host-visitor-status/host-visitor-status.component';
import { CreateIncidentComponent } from './components/create-incident/create-incident.component';
import { WebcamModule } from 'ngx-webcam';
import { SharedPipesModule } from '../../shared/pipe/shared-pipes.module';

@NgModule({
  declarations: [
    VisitorPassComponent,
    SecurityPassComponent,
    UserAdditionalDetailsComponent,
    VisitorEntryComponent,
    HostApprovalComponent,
    SecurityContainerComponent,
    EmployeeRegistrationFormComponent,
    AumyeEmergencyRespondComponent,
    HostVisitorStatusComponent,
    CreateIncidentComponent,
  ],
  imports: [
    CommonModule,
    SecurityPassRoutingModule,
    MaterialModule,
    QRCodeModule,
    DialogPopUpsModule,
    NgxMatIntlTelInputComponent,
    WebcamModule,
    SharedPipesModule,
  ],
  exports: [HostApprovalComponent, HostVisitorStatusComponent],
})
export class SecurityPassModule {}
